<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.clientName }}</a>
  </div>
</template>

<script>
//import store from "../../../../store/index";
export default {
  name: "HyperlinkForNfcMovilReports",
  show(ops) {
    ops;
    //console.log("hola", ops)
    ops.row.OpenDetail(ops.row);
    /*
    store.dispatch("getAllCustomer", {
      empresaid: ops.row.Empresaid
    });
    */
  }
};
</script>
